import React from 'react'
import FlexView from 'react-flexview/lib'
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core'
import { CoverageTypePopover } from '../../Core/Popover/CoverageTypePopover'
import { COVERAGE_TYPES } from '../../../models/insurance-models/CoverageType'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'

export const CustomizeCoverageType = () => {
  const offerContex = React.useContext(BuyingInsuranceContextStore)

  const [coverageType, setCoverageType] = React.useState(
    offerContex.coverageType
  )

  const onCoverateTypeChange = (e) => {
    offerContex.changeCoverageType(e.target.value)
    setCoverageType(e.target.value)
  }

  return (
    <React.Fragment>
      <FlexView
        vAlignContent={'center'}
        className="text-body bold black margin-top-basic">
        Select Coverage Type <CoverageTypePopover />
      </FlexView>
      {/* <div className="text-body dark-grey margin-top-small">Would you like your policy to auto-renew?</div> */}
      <RadioGroup value={coverageType} onChange={onCoverateTypeChange}>
        <FlexView className="margin-top-basic">
          <FormControlLabel
            value={COVERAGE_TYPES.LIABILITY}
            control={<Radio color="primary" />}
            label={<div className="text-small">Third Party Liability</div>}
          />
          <FormControlLabel
            value={COVERAGE_TYPES.COMBINED}
            control={<Radio color="primary" />}
            label={<div className="text-small">Combined Coverage</div>}
          />
        </FlexView>
      </RadioGroup>
    </React.Fragment>
  )
}
